'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_PharmacyAppUpdate$$anon$110(evaluator$44) {
  this.Lapp_api_PharmacyAppUpdate$$anon$110__f_evaluator$20 = null;
  this.Lapp_api_PharmacyAppUpdate$$anon$110__f_evaluator$20 = evaluator$44;
}
export { $c_Lapp_api_PharmacyAppUpdate$$anon$110 as $c_Lapp_api_PharmacyAppUpdate$$anon$110 };
$c_Lapp_api_PharmacyAppUpdate$$anon$110.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_PharmacyAppUpdate$$anon$110.prototype.constructor = $c_Lapp_api_PharmacyAppUpdate$$anon$110;
/** @constructor */
function $h_Lapp_api_PharmacyAppUpdate$$anon$110() {
}
export { $h_Lapp_api_PharmacyAppUpdate$$anon$110 as $h_Lapp_api_PharmacyAppUpdate$$anon$110 };
$h_Lapp_api_PharmacyAppUpdate$$anon$110.prototype = $c_Lapp_api_PharmacyAppUpdate$$anon$110.prototype;
$c_Lapp_api_PharmacyAppUpdate$$anon$110.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_PharmacyAppUpdate$$anon$110.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_PharmacyAppUpdate$$anon$110__f_evaluator$20.apply__O();
  return ((v !== null) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_PharmacyAppUpdate$$anon$110.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_PharmacyAppUpdate$$anon$110 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_PharmacyAppUpdate$$anon$110, "app.api.PharmacyAppUpdate$$anon$110", ({
  Lapp_api_PharmacyAppUpdate$$anon$110: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_PharmacyAppUpdate$$anon$110 as $d_Lapp_api_PharmacyAppUpdate$$anon$110 };
//# sourceMappingURL=app.api.-Pharmacy-App-Update$$anon$110.js.map
